import { IRoleTypeService } from "../../service/role/RoleTypeService";

export default class RemoveRoleTypeReportingTypeInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }
  async execute(roleTypeReportingTypeIds: string[]) {
    return this.roleTypeService.removeRoleTypeReportingTypes(
      roleTypeReportingTypeIds
    );
  }
}
